var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorizontalFlip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3959_1023)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 17.7273H15.3333V16.4545H14V17.7273ZM16.6667 10.0909H18V8.81818H16.6667V10.0909ZM6 7.54545V16.4545C6 17.1545 6.6 17.7273 7.33333 17.7273H10V16.4545H7.33333V7.54545H10V6.27273H7.33333C6.6 6.27273 6 6.84545 6 7.54545ZM16.6667 6.27273V7.54545H18C18 6.84545 17.4 6.27273 16.6667 6.27273ZM11.3333 19H12.6667V5H11.3333V19ZM16.6667 15.1818H18V13.9091H16.6667V15.1818ZM14 7.54545H15.3333V6.27273H14V7.54545ZM16.6667 12.6364H18V11.3636H16.6667V12.6364ZM16.6667 17.7273C17.4 17.7273 18 17.1545 18 16.4545H16.6667V17.7273Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3959_1023",
    x: -4,
    y: -4,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3959_1023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3959_1023",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalFlip);
export default __webpack_public_path__ + "static/media/horizontal_flip.71868ac25eba1d15c66ea8ca18eaed8e.svg";
export { ForwardRef as ReactComponent };